const getFromLS = (key: string) => window.localStorage.getItem(key) || null;

const removeFromLS = (key: string) => window.localStorage.removeItem(key);
const setToLS = (key: string, data: string) => window.localStorage.setItem(key, data);

const clearLS = () => window.localStorage.clear();

export {
  getFromLS,
  removeFromLS,
  setToLS,
  clearLS,
}
